import { isEmpty } from 'lodash-es';
import { ExtractSnippetsProps, SnippetType } from './types';

const extractSnippets = ({
  snippetIds,
  data,
  fallback
}: ExtractSnippetsProps): SnippetType => {
  if (!data) {
    return {};
  }

  const result = { ...(data || {}) };

  return snippetIds?.reduce((memo, id) => {
    return {
      ...memo,
      [id]: (!isEmpty(data?.[id]) && data?.[id]) || fallback?.[id]
    };
  }, result);
};

export default extractSnippets;
